import { PageRef } from 'providers/page-ref';

export type CustomizeHomepagePageParams = {};

export const ICustomizeHomepagePage: PageRef<CustomizeHomepagePageParams, void> = {
  pageName: 'CustomizeHomepagePage',
} as PageRef<CustomizeHomepagePageParams, void>;
